import React from 'react';
import DogDisplayPage from './DogDisplayPage';
import { WidePhoto, TallPhoto, SquarePhoto } from './Constants';
import scarlett1 from './assets/images/scarlett/1.jpg';
import scarlett2 from './assets/images/scarlett/2.jpg';
import scarlett3 from './assets/images/scarlett/3.jpg';
import scarlett4 from './assets/images/scarlett/4.jpg';
import scarlett5 from './assets/images/scarlett/5.jpg';
import scarlett6 from './assets/images/scarlett/6.jpg';
import scarlett7 from './assets/images/scarlett/7.jpg';
import scarlett8 from './assets/images/scarlett/8.jpg';
import scarlett9 from './assets/images/scarlett/9.jpg';
import scarlett10 from './assets/images/scarlett/10.jpg';
import scarlett11 from './assets/images/scarlett/11.jpg';
import scarlett12 from './assets/images/scarlett/12.jpg';
import scarlett13 from './assets/images/scarlett/13.jpg';
import scarlett14 from './assets/images/scarlett/14.jpg';
import scarlett15 from './assets/images/scarlett/15.jpg';
import scarlett16 from './assets/images/scarlett/16.jpg';
import scarlett17 from './assets/images/scarlett/17.jpg';
import scarlett18 from './assets/images/scarlett/18.jpg';
import scarlett19 from './assets/images/scarlett/19.jpg';
import scarlett20 from './assets/images/scarlett/20.jpg';
import scarlett21 from './assets/images/scarlett/21.jpg';
import scarlett22 from './assets/images/scarlett/22.jpg';
import scarlett23 from './assets/images/scarlett/23.jpg';
import scarlett24 from './assets/images/scarlett/24.jpg';
import scarlett25 from './assets/images/scarlett/25.jpg';

const photos = [
  { src: scarlett1, ...WidePhoto },
  { src: scarlett2, ...WidePhoto },
  { src: scarlett3, ...SquarePhoto },
  { src: scarlett4, width: 200, height: 450 }, // non-standard size
  { src: scarlett5, width: 200, height: 80 }, // non-standard size
  { src: scarlett6, ...WidePhoto },
  { src: scarlett7, width: 200, height: 450 }, // non-standard size,
  { src: scarlett8, width: 450, height: 200 }, // non-standard size
  { src: scarlett9, width: 200, height: 450 }, // non-standard size
  { src: scarlett10, ...TallPhoto },
  { src: scarlett11, width: 225, height: 450 }, // non-standard size
  { src: scarlett12, ...TallPhoto },
  { src: scarlett13, width: 200, height: 450 }, // non-standard size
  { src: scarlett14, ...SquarePhoto },
  { src: scarlett15, ...TallPhoto },
  { src: scarlett16, width: 450, height: 200 }, // non-standard size
  { src: scarlett17, ...WidePhoto },
  { src: scarlett18, width: 270, height: 450 }, // non-standard size
  { src: scarlett19, ...WidePhoto },
  { src: scarlett20, ...WidePhoto },
  { src: scarlett21, width: 200, height: 450 }, // non-standard size
  { src: scarlett22, ...SquarePhoto },
  { src: scarlett23, ...SquarePhoto },
  { src: scarlett24, ...WidePhoto },
  { src: scarlett25, width: 225, height: 450 }, // non-standard size
];

const Scarlett = () => {
  return (
    <DogDisplayPage photos={photos}>
      <h1 className="female">
        <i className="far fa-venus"></i>Scarlett (retired)
      </h1>
      <table className="dog-chart">
        <tbody>
          <tr>
            <td><span className="title">Name</span>LUNANOVA'S FRANKLY MY DEAR, I DON'T GIVE A DAMN</td>
            <td><span className="title">Owner</span>CAROLYNNE ISSA / JOANNE SKALOS</td>
            <td width="100px"><span className="title">CKC Registration</span>#JQ4124251</td>
          </tr>
          <tr>
            <td><span className="title">Sire</span>CH LUNANOVA'S CHILKO FREESTONE</td>
            <td><span className="title">Dam</span>CH LUNANOVA LET THE STORM RAGE ON</td>
          </tr>
          <tr>
            <td><span className="title">Coat Type</span>Wavy</td>
            <td><span className="title">Coat Colour</span>BLACK</td>
          </tr>
          <tr>
            <td><span className="title">CAER</span>NORMAL</td>
            <td><span className="title">CDDY/IVVD</span>normal</td>
            <td><span className="title">EOPRA</span>normal</td>
          </tr>
          <tr>
            <td><span className="title">GM-1</span>normal</td>
            <td><span className="title">Improper Coat</span>normal</td>
            <td><span className="title">JDCM</span>normal</td>
            <td><span className="title">MICROPHTHALMIA SYNDROME</span>normal</td>
          </tr>
          <tr>
            <td><span className="title">OFA Hips</span>GOOD (ELBOWS NORMAL)</td>
            <td><span className="title">PRA</span>normal</td>
          </tr>
        </tbody>
      </table>
    </DogDisplayPage>
  )

}
export default Scarlett;
